import React from 'react';
import'./Services.css'
import {BiCheck} from 'react-icons/bi'


const Services = () => {
    return (
        <section id='services'>
         <h5>What I Offer</h5>
         <h2>Services</h2>
         <div className="container services_container">
            <article className='service'>
                    <div className="service_head">
                        <h3>UI/UX Design</h3>
                    </div>
                    <ul className="service_list">
                            <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                                {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatu!</p> */}
                                <p>Designing the overall look and feel of a website, including layout, color schemes.</p>
                            </li>
                            {/* <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                              
                                <p>Creating websites that adapt and display properly on different devices and
                                     screen sizes, such as desktops, laptops, tablets, and mobile phones.</p>
                            </li> */}
                            <li>
                                <BiCheck className='service_list-icon'></BiCheck>

                                <p>Focusing on enhancing the usability of a website to provide a positive experience for users.</p>
                            </li>
                            <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                              
                                <p>Designing the graphical elements and interactive components of a website to ensure a seamless and visually appealing user interface.</p>
                            </li>
                            <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                               
                                <p>Organizing and structuring the content on a website to improve navigation and user engagement.</p>
                            </li>
                            {/* <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                             
                               <p>Creating online stores with features like product listings, shopping carts, secure payment gateways, and order management systems.</p>
                            </li> */}
                          
                    </ul>
            </article>
            {/* ui/ux end */}
            <article className='service'>
                    <div className="service_head">
                        <h3>Frontend Development</h3>
                    </div>
                    <ul className="service_list">
                         
                            <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                            
                                <p> Implementing interactive and dynamic features on websites using JavaScript and Typescript and various libraries and frameworks like React.js,Next.js,Redux </p>
                            </li>
                            {/* <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                               
                                <p> Building SPAs that provide a seamless browsing experience by dynamically updating content without reloading the entire page.</p>
                            </li> */}
                            <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                           
                                <p> Ensuring websites function correctly across different web browsers and their various versions.</p>                            </li>
                            <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                           
                                <p>Optimizing front-end code, assets, and page loading times to improve website performance, including techniques like minification, compression, lazy loading, and caching.</p>
                            </li>
                            <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                             
                                <p> Utilizing popular front-end frameworks like Material-UI to expedite development and create consistent and responsive designs.</p>
                            </li>
                            {/* <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                             
                                <p> Enhancing the user interface (UI) and user experience (UX) through intuitive navigation, well-designed forms, interactive elements, and seamless interactions.</p>
                            </li> */}
                          
                    </ul>
            </article>
            {/* Web Development */}
            <article className='service'>
                    <div className="service_head">
                        <h3>Backend Development</h3>
                    </div>
                    <ul className="service_list">
                            <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                             
                                <p>Writing code using backend programming languages such as Node.js to handle server-side operations, data processing and implemented database like MongoDb,Mysql</p>
                            </li>
                            <li>
                              
                                {/* <p> Designing and implementing databases using technologies like MySQL, MongoDB. This includes data modeling, query optimization, and ensuring data integrity.</p> */}
                                {/* <p> Designing and implementing databases using technologies like MySQL, MongoDB.</p> */}
                            </li>
                            {/* <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                              
                                <p> Creating APIs that enable communication and data exchange between different software systems or applications</p>
                            </li> */}
                            <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                                {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatu!</p> */}
                                <p> Utilizing backend frameworks and libraries like Express.js.deployment for vercel ,netlify, firebase</p>
                            </li>
                            <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                          
                                <p> Implementing security measures such as encryption, authentication, and authorization to protect data and ensure secure access to backend resources.</p>
                            </li>
    
                            {/* <li>
                                <BiCheck className='service_list-icon'></BiCheck>
                             
                                <p>  Implementing error handling mechanisms, logging, and monitoring solutions to identify and fix issues in the backend system.</p>
                            </li> */}
                          
                    </ul>
            </article>
            {/* Data entry */}
         </div>
        </section>
    );
};

export default Services;